import { Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Outlet } from 'react-router';
import styled from 'styled-components';
import { TopBar } from '../components/top_bar.component';

interface OutletPageProps {
	padding?: string;
}
export function OutletPage({ padding }: OutletPageProps) {
	return (
		<Flex
			grow={1}
			style={{
				height: '100%',
				minHeight: '100%',
			}}
		>
			<TopBar.Root>
				<TopBar.Outlet />
				<StyledContainer padding={padding}>
					<Outlet />
				</StyledContainer>
			</TopBar.Root>
		</Flex>
	);
}

const StyledContainer = styled.div<{ padding?: string }>`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding: ${(props) => props.padding || tokens.spacing.x2};

	${tokens.breakpointQuery.small} {
		padding: ${(props) => props.padding || `${tokens.spacing.x3} ${tokens.spacing.x4} ${tokens.spacing.x4}`};
		max-width: 580px;
		width: 100%;
		margin: 0 auto;
	}
`;
